export default "__VITE_ASSET__DqSW6iGd__"